import { render, staticRenderFns } from "./unpublished-donations-error.vue?vue&type=template&id=07bc1e7e&scoped=true&"
import script from "./unpublished-donations-error.vue?vue&type=script&lang=js&"
export * from "./unpublished-donations-error.vue?vue&type=script&lang=js&"
import style0 from "./unpublished-donations-error.vue?vue&type=style&index=0&id=07bc1e7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bc1e7e",
  null
  
)

export default component.exports